import { imageUrl, type ImageTransformOptions } from '@inboundhost/shared';

const IMAGES_BASE = (import.meta.env.VITE_IMAGES_BASE_URL ?? '').replace(/\/$/, '');

/** Build an image worker URL for previewing an R2 key in the admin UI. */
export function imagePreviewUrl(key: string, opts?: ImageTransformOptions): string {
  return imageUrl(key, opts, IMAGES_BASE);
}
